module.exports = __webpack_public_path__ + "img/10.c5c79616.jpg";